module.exports = __webpack_public_path__ + "static/boston-680556eeb133d1f1382ec3b37ee7acad.png";